import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { Label } from '../Label/Label'
import { X } from 'react-bootstrap-icons'

interface PropData {
  isAllowDuplicate: boolean
  onChange: (value: string[]) => void
  selected: string[]
  title?: string
  showStar?: boolean
}

const TagInput = ({
  isAllowDuplicate = false,
  onChange,
  selected = [],
  title = '',
  showStar = false
}: PropData) => {
  const [inputValue, setInputValue] = useState<string>('')
  const [tags, setTags] = useState<string[]>(selected || [])

  useEffect(() => {
    if (selected && selected.length > 0) {
      setTags(selected)
    }
  }, [selected])

  const onChangeTag = (e: any) => {
    if (e.key !== 'Enter') return
    const newTable = e.target.value.trim()
    const currentTables = tags || []
    if (newTable && e.key == 'Enter') {
      if (isAllowDuplicate) {
        const updatedTables = [...currentTables, newTable]
        onChange(updatedTables)
        e.target.value = ''
      }
      if (newTable && !currentTables.includes(newTable) && !isAllowDuplicate) {
        const updatedTables = [...currentTables, newTable]
        onChange(updatedTables)
        e.target.value = ''
      } else if (currentTables.length > 0 && !isAllowDuplicate) {
        toast.error('Duplicate value is not allowed')
      }
    }
  }

  const removeTag = (index: number) => {
    const updatedTags = tags.filter((_, i) => i !== index) 
    updatedTags.length === 0 && setTags([])
    onChange(updatedTags)
  }

  return (
    <>
      <div className="form-group mb-0">
        <Label title={title} showStar={showStar} />
        <input
          className="form-control"
          type="text"
          onKeyPress={(e: any) => {
            onChangeTag(e)
          }}
          onKeyUp={(e: any) => {
            e.preventDefault()
            e.stopPropagation()
          }}
        />
      </div>
      <div className="d-flex flex-wrap mt-2">
        {tags &&
          !!tags.length &&
          tags.map((item: string, index: number) => {
            return (
              <p key={index.toString()} className="gery-badge m-1">
                {item} <X className="cursor-pointer" onClick={() => removeTag(index)} />{' '}
              </p>
            )
          })}
      </div>
    </>
  )
}

export default TagInput
